import dayjs, { Dayjs } from 'dayjs';
import { DefaultRange, PricesByRange } from '../models';

import isTodayPlugin from 'dayjs/plugin/isToday';
import isTomorrowPlugin from 'dayjs/plugin/isTomorrow';
import isYesterdayPlugin from 'dayjs/plugin/isYesterday';

dayjs.extend(isTodayPlugin);
dayjs.extend(isTomorrowPlugin);
dayjs.extend(isYesterdayPlugin);

export const dateFormatRange = 'YYYY-MM-DD';
export const dateHoursFormatRange = 'YYYY-MM-DD, HH:mm';

export function millisToMinutesAndSecondsString(millis: number): string {
  const minutes = Math.floor(millis / 60000);
  const seconds = (millis % 60000) / 1000;
  const secondsInString = seconds.toFixed(0);
  return minutes + ':' + (seconds < 10 ? '0' : '') + secondsInString;
}

export const deassembleRange = (
  range: string,
  pricesByRange?: PricesByRange
) => {
  const castedRange = range as `${string}/${string}`;

  const price = pricesByRange?.[castedRange];
  const [rangeStartDate, rangeEndDate] = castedRange.split('/');
  const fromTime = dayjs(rangeStartDate).format('HH:mm');
  const endTime = dayjs(rangeEndDate).format('HH:mm');
  const date = dayjs(rangeStartDate).format(dateFormatRange);
  return { fromTime, endTime, date, price };
};

export const fromHoursStringToDayjs = (hourString: string) => {
  const [hours, minutes] = hourString.split(':');
  return dayjs()
    .set('minutes', +minutes)
    .set('hours', +hours)
    .set('seconds', 0)
    .set('milliseconds', 0);
};

export const normalizeDefaultRange = (dr: string): DefaultRange => {
  const { fromTime, endTime, date } = deassembleRange(dr);
  return {
    date,
    from: fromTime,
    to: endTime,
  };
};

export type NormalizedRange = {
  from: Dayjs;
  to: Dayjs;
};

export const extractRange = (timeRange: string): NormalizedRange => {
  const [from, to] = timeRange.split('/');
  return {
    from: dayjs(from),
    to: dayjs(to),
  };
};

export const isToday = (
  date: string | Dayjs,
  stringDateFormat?: string
): boolean => {
  if (typeof date === 'string') {
    const convertedDate = dayjs(date, stringDateFormat);
    return convertedDate.isToday();
  } else {
    return date.isToday();
  }
};

export const isTomorrow = (
  date: string | Dayjs,
  stringDateFormat?: string
): boolean => {
  if (typeof date === 'string') {
    const convertedDate = dayjs(date, stringDateFormat);
    return convertedDate.isTomorrow();
  } else {
    return date.isTomorrow();
  }
};

export const isYesterday = (
  date: string | Dayjs,
  stringDateFormat?: string
): boolean => {
  if (typeof date === 'string') {
    const convertedDate = dayjs(date, stringDateFormat);
    return convertedDate.isYesterday();
  } else {
    return date.isYesterday();
  }
};
